<mat-card>
  <mat-card-header>
    <div class="flex justify-between" style="width: 100%;">
      <div class="text-lg self-center">{{!isDetail ? 'ยื่น' : 'รายละเอียด'}}คำร้องขอต่ออายุ อ.2</div>
      <div>
        <button mat-icon-button class="close-button" [mat-dialog-close]="false">
          <i class="ti ti-x text-white"></i>
        </button>
      </div>
    </div>
  </mat-card-header>
  <mat-dialog-content class="flex flex-col mat-typography" style="gap: 15px; padding-bottom: 12px;">
    <div class="pl-5 pr-5 flex flex-row justify-center" style="gap: 14px;">
      <div class="flex flex-row justify-center gap-3" style="width: 50%">
        <div class="flex flex-col justify-center" style="width: 50%">
          <h4>เลขที่ใบอนุญาตกระทรวงพาณิชย์</h4>
        </div>
        <div class="flex flex-row gap-3" style="width: 50%">
          <div class="flex flex-col justify-center">:</div>
          <!-- <div [formGroup]="searchShipperForm" class="flex-1"> -->
          <mat-form-field class="flex-1">
            <input required autocomplete="off" readonly matInput placeholder="เลขที่ใบอนุญาตกระทรวงพาณิชย์"
              [(ngModel)]="form.docNo" name="o2DocNo" #o2DocNo="ngModel">
          </mat-form-field>
          <!-- </div> -->
        </div>
      </div>

      <div class="flex flex-row justify-center gap-3" style="width: 50%">
        <div class="flex flex-col justify-center" style="width: 50%">
          <h4>วันที่เอกสารหมดอายุ (เดิม)</h4>
        </div>
        <div class="flex flex-row gap-3" style="width: 50%">
          <div class="flex flex-col justify-center">:</div>
          <!-- <div [formGroup]="searchShipperForm" class="flex-1"> -->
          <mat-form-field class="flex-1" (click)="exDates.open()">
            <input required autocomplete="off" disabled readonly placeholder="วันที่เอกสารหมดอายุ (เดิม)" matInput
              [matDatepicker]="exDates" [(ngModel)]="form.expireDate" [max]="form.expireDateMax" name="expireDate"
              #expireDate="ngModel">
            <mat-datepicker-toggle matSuffix [for]="exDates"></mat-datepicker-toggle>
            <mat-datepicker #exDates></mat-datepicker>
            <mat-error>กรุณาระบุ</mat-error> </mat-form-field>
          <!-- </div> -->
        </div>
      </div>
    </div>

    <div class="pl-5 pr-5 flex flex-row justify-center gap-3" *ngIf="!isDetail">
      <div class="flex">
        <div class="basis-1/2 f18" style="align-self: center;">
          <div class="file-uploader-block">
            <dx-file-uploader [allowCanceling]="true" [(value)]="value" (onValueChanged)="onFileChangedBr($event)"
              [multiple]="true" [uploadMode]="'instantly'" accept="image/gif, image/jpeg, image/png ,image/jpg"
              [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']">
            </dx-file-uploader>
            <span class="note" style="margin-left: 10px; font-size: 13px;">รูปแบบไฟล์ที่อนุญาต: <span>.jpg, .jpeg, .gif,
                .png</span>.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pl-5 pr-5 flex flex-row justify-center gap-3">
      <div class="mat-elevation-z8 w100">
        <dx-data-grid id="gridContainer" [dataSource]="dataSource" [columnAutoWidth]="true" [showBorders]="true"
          [allowColumnReordering]="true" [showBorders]="true" [noDataText]="'ยังไม่ได้แนบสำเนา อ.2'">
          <dxi-column alignment="center" dataField="documentName" caption="ชื่อเอกสาร">
          </dxi-column>
          <dxi-column alignment="center" dataField="documentSize" caption="ขนาดของเอกสาร">
          </dxi-column>
          <dxi-column alignment="center" dataField="fileExtension" caption="ชนิดเอกสาร">
          </dxi-column>
          <dxi-column alignment="center" cellTemplate="action" caption="Action">
          </dxi-column>
          <div *dxTemplate="let row of 'action'">
            <button (click)="showImg(row.data.linkDoc)" mat-icon-button matTooltip="รายละเอียด">
              <i class="ti ti-info-circle"></i>
            </button>
            <button mat-icon-button *ngIf="!isDetail" (click)="deleteImg(row.data)" color="accent">
              <i class="ti ti-trash"></i>
            </button>
          </div>
          <div *dxTemplate="let row of 'itemStatus'">
          </div>
        </dx-data-grid>
      </div>
    </div>

    <div class="pl-5 pr-5 flex flex-row justify-center" style="gap: 14px;" *ngIf="isStaff">
      <div class="flex flex-row justify-center gap-3" style="width: 70%">
        <div class="flex flex-col justify-center" style="width: 35%">
          <h4>วันที่เอกสารหมดอายุ (ใหม่):</h4>
          <h4 style="color: red">(เฉพาะกรณีที่อนุมัติคำร้อง)</h4>
        </div>
        <div class="flex flex-row gap-3" style="width: 65%">
          <div class="flex flex-col justify-center">:</div>
          <mat-form-field class="flex-1" (click)="nexDates.open()">
            <input required autocomplete="off" readonly placeholder="วันที่เอกสารหมดอายุ (ใหม่)" matInput
              [matDatepicker]="nexDates" [(ngModel)]="form.newExpireDate" [min]="form.expireDate" [max]="form.expireDateMax" name="expireDate"
              #expireDate="ngModel">
            <mat-datepicker-toggle matSuffix [for]="nexDates"></mat-datepicker-toggle>
            <mat-datepicker #nexDates></mat-datepicker>
            <mat-error>กรุณาระบุ</mat-error> </mat-form-field>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex justify-center w100" style="padding-bottom: 12px;">
      <div class="flex" style="flex-wrap: nowrap;align-items: center;gap: 7x;" *ngIf="!isStaff">
        <button mat-raised-button color="accent" (click)="sentRenew(2)" style="width: 100px;"
          *ngIf="!isDetail">ยื่นคำร้อง</button>
        <button mat-raised-button [mat-dialog-close] style="width: 100px;">ยกเลิก</button>
      </div>
      <div class="flex" style="flex-wrap: nowrap;align-items: center;gap: 7px;" *ngIf="isStaff">
        <button mat-raised-button (click)="sentRenew(9)" style="width: 100px;">อนุมัติ</button>
        <button mat-raised-button (click)="sentRenew(4)" style="width: 100px;">ไม่อนุมัติ</button>
        <button mat-raised-button (click)="openO2Copy()" style="gap: 6px;">
          <mat-icon svgIcon="heroicons_outline:information-circle"></mat-icon> ดูรายละเอียดเอกสาร
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</mat-card>